import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FooterDrawerService } from './footer-drawer.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-footer-drawer',
    styleUrls: ['footer-drawer.component.scss'],
    templateUrl: 'footer-drawer.component.html',
    standalone: false
})
export class FooterDrawerComponent {
    constructor(readonly footerDrawerService: FooterDrawerService) {}
}
